// CORE
import React, { useContext, useState } from "react";

// THIRD-PARTY LIBRARIES
import { Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

// CONTEXT
import { Context } from "components/Form";

// HELPERS
import { addClassError, inputRegister } from "helpers/forms";
import { copyTextToClipboard } from "helpers/functions";

// COMPONENTS
import InputTitle from "../input-title";
import InputError from "../input-error";

// ASSETS
import { ReactComponent as ViewIcon } from "./assets/eye.svg";
import { ReactComponent as CopyIcon } from "./assets/copy.svg";

// STYLES
import styles from "./styles/style.module.scss";

export const Input = ({
    register: registerOverride = () => {},
    errors: errorsOverride = {},
    getValues: getValuesOverride = () => {},
    name,
    langId = name,
    locale = "",
    rules = { required: <FormattedMessage id="requiredField" /> },
    xs = "12",
    lg = xs !== "12" ? xs : "6",
    breakpoints = { lg, xs },
    children,
    ...rest
}) => {
    const {
        register = registerOverride,
        errors = errorsOverride,
        getValues = getValuesOverride,
    } = useContext(Context);

    const [passwordToggle, setPasswordToggle] = useState(false);

    // const passwordToggleClass = rest?.toggleview ? "ps-5" : "";

    const renderPasswordToggle = rest?.type === "password" &&
        rest?.toggleView && (
            <div
                className="extra-btn-end"
                onClick={() => {
                    setPasswordToggle(!passwordToggle);
                }}
            >
                <ViewIcon />
            </div>
        );

    const wrapperClass =
        rest?.copyable || rest?.extrabtnicon || rest?.toggleView
            ? "has-button"
            : "";

    const renderCopyable = rest?.copyable && (
        <div
            className="extra-btn-start"
            onClick={() => {
                if (typeof getValues === "function")
                    copyTextToClipboard(getValues(name) || rest?.value);
            }}
        >
            <CopyIcon />
        </div>
    );

    const renderExtraBtn = rest?.extrabtnicon && (
        <div className="extra-btn-start " onClick={rest?.extrabtnfunc}>
            {rest?.extrabtnicon}
        </div>
    );

    return (
        <Col {...breakpoints} as="label">
            <div className={styles["input-container"]}>
                <div
                    className={`input-wrapper ${
                        rules?.required ? "required" : ""
                    }`}
                >
                    {!!langId && <InputTitle name={langId} locale={locale} />}
                    <div
                        className={`${wrapperClass} ${
                            rest?.copyable || rest?.extrabtnicon
                                ? "has-inline-start-btn"
                                : ""
                        } ${
                            rest?.type === "password" || rest?.toggleView
                                ? "has-inline-end-btn"
                                : ""
                        } ${
                            rest?.type && rest?.type === "radio" ? "radio" : ""
                        } ${
                            rest?.type && rest?.type === "checkbox"
                                ? "checkbox"
                                : ""
                        } `}
                    >
                        {renderPasswordToggle}
                        <Form.Control
                            autoComplete="new-input"
                            formNoValidate
                            spellCheck="false"
                            className={` ${addClassError(
                                errors,
                                name,
                                locale
                            )} ${rest?.inputClass || ""}`}
                            {...inputRegister(register, name, locale, rules)}
                            {...rest}
                            {...(passwordToggle ? { type: "text" } : {})}
                        />
                        {renderCopyable}
                        {renderExtraBtn}
                        {children}
                    </div>
                    <InputError name={name} locale={locale} errors={errors} />
                </div>
            </div>
        </Col>
    );
};

export default Input;
